import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSnackbar } from "notistack";
import { useMutation } from "react-query";
import { postData } from "../../../api/api";
import { getQueryConfiguration } from "../../../utils";
import ActivateAccountVerifyDialog from "./ActivateAccountVerifyDialog";
import ActivateAccountCompleteDialog from "./ActivateAccountCompleteDialog";

const ActivateAccountDialog = (props) => {
    const [completed, setCompleted] = useState(false);
    const [applicationName, setApplicationName] = useState();
    const [applicationUrl, setApplicationUrl] = useState();
    const [mutationError, setMutationError] = useState();

    const { applicationId, token } = getQueryConfiguration();
    const { enqueueSnackbar } = useSnackbar();

    const mutation = useMutation((resource) => postData("/accounts/verify-email", resource), {
        onMutate: () => {
            // do nothing
        },
        onSuccess: (data) => {
            props.onVerify?.();

            setCompleted(true);
            setApplicationName(data?.data.humanName);
            setApplicationUrl(data?.data.url);

            enqueueSnackbar("Account email has been verified", {
                variant: "info",
            });
        },
        onError: (error) => {
            setMutationError(error.response.data.message);
        },
    });

    const handleVerify = (verificationCode) => {
        mutation.mutate({
            applicationId,
            token: verificationCode,
        });
    };

    useEffect(() => {
        const doIt = async () => {
            if (token && applicationId) {
                mutation.mutate({
                    applicationId: applicationId,
                    token: token,
                });
            }
        };

        doIt();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (completed) {
        return (
            <ActivateAccountCompleteDialog
                open={props.open}
                applicationName={applicationName}
                applicationUrl={applicationUrl}
            />
        );
    } else {
        return (
            <ActivateAccountVerifyDialog
                open={props.open}
                verificationCode={token}
                saving={mutation.isLoading}
                error={mutationError}
                onVerify={handleVerify}
                onCancel={props.onClose}
            />
        );
    }
};

ActivateAccountDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
};

export default ActivateAccountDialog;
